import { Button, Card, CardContent, Grid, GridColumn, Text } from 'telia-front-react';
import { observer } from 'mobx-react';
import * as React from 'react';
import BasePollableLoginStore from '../../stores/BasePollableLoginStore';
import useStores from '../../stores/UseStores';
import { runInTeliaRumService } from '../../util/TeliaOtelUtil';

interface PendingLoginProps {
  pollableLoginStore: BasePollableLoginStore;
  method: 'mid' | 'sid';
}

const PendingLogin = (props: PendingLoginProps) => {
  const {
    translateStore: { translate },
  } = useStores();
  const { pollableLoginStore, method } = props;

  const handleCancelLogin = () => {
    runInTeliaRumService(`Autentimise katkestamine (${method.toUpperCase()})`, () => {
      pollableLoginStore.cancelLogin();
    });
  };

  return (
    <span aria-live="polite">
      {pollableLoginStore.status === 'PENDING' && (
        <Text>
          <Grid align={['center-sm']}>
            <GridColumn width={['sm-8', 'md-6', 'lg-4']}>
              <Text className="text-center">
                <p>{translate(`${method}.instruction`)}</p>
                <Card>
                  <CardContent>
                    <span className="sr-only">{pollableLoginStore.verificationCode?.split('').join(' ')}</span>
                    <p className="h2 text-center" aria-hidden="true">
                      {pollableLoginStore.verificationCode}
                    </p>
                  </CardContent>
                </Card>
                <p className="text-small text-light">
                  {translate(`${method}.waiting`)}
                  <Button text={translate('mid.cancel')} link={true} size="small" onClick={() => handleCancelLogin()} />
                </p>
              </Text>
            </GridColumn>
          </Grid>
        </Text>
      )}
    </span>
  );
};

export default observer(PendingLogin);
